import React from 'react'
import { Balloon } from 'components'
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay'
import { Box } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { Corner } from 'components/balloon'
import useStyles from './Styles'
import { navigate } from '@reach/router'
import cx from 'classnames'

interface IPlaylistButtonProps {
  visible: boolean
}

const PlaylistButton: React.FC<IPlaylistButtonProps> = ({ visible }) => {
  const theme = useTheme()
  const classes = useStyles({})

  return (
    <React.Fragment>
      {visible && (
        <Box className={cx(classes.root, 'playlist-button')} onClick={() => navigate('/talent-playlists')}>
          <Balloon bgColor={theme.palette.common.lightOrange} corner={Corner.BottomRight} size={40}>
            <PlaylistPlayIcon className={classes.icon} />
          </Balloon>
        </Box>
      )}
    </React.Fragment>
  )
}

export default PlaylistButton
